import { Component } from '@verndale/core';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'bootstrap/js/dist/modal';

/* eslint-disable */
class Module extends Component {
  setupDefaults() {
    this.dom = {
      $tabButtons: this.el.querySelectorAll('.store-department-tablist .btn'),
      $tabPannels: this.el.querySelectorAll('.store-department-tabpanel')
    };

    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);
    this.initModal();
  }

  addListeners() {
    this.dom.$tabButtons.forEach(btn => {
      btn.addEventListener('click', this.toggleTab.bind(this));
    });
  }

  toggleTab(e) {
    this.dom.$tabButtons.forEach(btn => {
      if (btn === e.currentTarget) {
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.setAttribute('aria-selected', 'false');
      }
    });
    this.dom.$tabPannels.forEach(pannel => {
      if (
        pannel.getAttribute('id') ===
        e.currentTarget.getAttribute('aria-controls')
      ) {
        pannel.removeAttribute('hidden');
      } else {
        pannel.setAttribute('hidden', 'hidden');
      }
    });
  }

  initModal() {
    if ($('.store-departments.multiple').length) {
      $('.store-departments.multiple').each(function () {
        var $deptMultiple = $(this),
          $mobileSelector = $deptMultiple.find(
            '.store-department-mobile-selector'
          ),
          $tabs = $deptMultiple.find('.store-department-tablist button'),
          $tabPanels = $deptMultiple.find('.store-department-tabpanel');

        $tabs.on('click', function () {
          var $tab = $(this);

          $tabs.attr('aria-selected', false);
          $tab.attr('aria-selected', true);
          $mobileSelector.html($tab.html());
          $tabPanels.attr('hidden', true);
          $tabPanels
            .filter('#' + $tab.attr('aria-controls'))
            .removeAttr('hidden');
        });

        $mobileSelector.on('click', function (e) {
          if ($mobileSelector.hasClass('active')) {
            $(document).off('click.storeDepartmentChanger');
            $mobileSelector.removeClass('active');
          } else {
            $mobileSelector.addClass('active');
            e.stopPropagation();
            $(document).one(
              'click.storeDepartmentChanger',
              function closeChanger(e) {
                $mobileSelector.removeClass('active');
              }
            );
          }
        });
      });
    }

    function buildTeamSlider() {
      var $slider = $('.hp-store-detail-modal-team-carousel'),
        slideCount = $slider.find('.hp-store-detail-modal-team-member').length,
        useFlickity =
          slideCount > 2 ||
          (slideCount === 6 && !window.isAboveBreakpoint('desktop'));

      if ($slider.data('flickity')) {
        $slider.flickity('destroy');
      }

      if (useFlickity) {
        $slider.flickity({
          adaptiveHeight: false,
          imagesLoaded: true,
          setGallerySize: true,
          pageDots: false,
          contain: true,
          cellAlign: 'left',
          wrapAround: true
        });
      }
    }

    function buildReviewSlider() {
      var $reviewItems = $('#mmx-reviews-v2-items');
      if ($reviewItems.html()) {
        if ($reviewItems.data('flickity')) {
          $reviewItems.flickity('destroy');
        }

        $reviewItems.closest('div.mmx-reviews-v2').addClass('active');

        $reviewItems.on('ready.flickity', function () {
          $reviewItems.find('.arw-item-mmx').css('height', '100%');
        });

        $reviewItems.flickity({
          cellAlign: 'left'
        });
      } else {
        $reviewItems.remove();
      }
    }

    var $modal = $('#storeDetailModal');
    $modal.on('shown.bs.modal', function () {
      buildTeamSlider();
      buildReviewSlider();
    });

    $('.store-modal-trigger').on('click', function (e) {
      e.preventDefault();
      $modal.modal('show');
    });
  }
}

export default Module;
